'use client';
import { datadogRum } from '@datadog/browser-rum';
import type { SegmentAbstraction } from '@repo/platform-analytics/lib/Segment';
import { getBotCookies } from '@repo/platform-utils/bot-cookies';
import { v4 as uuid } from 'uuid';
import { ABSMARTLY_EXPERIMENT_BUCKETING_DECISION_EVENT } from '../constants';
import type { BucketedEventParams } from '../types/absmartly';

export const logABSmartlyBucketingDecision = (
  params: BucketedEventParams,
  analytics: SegmentAbstraction,
) => {
  if (analytics) {
    const { botScore, isBot, isBotUserAgent, isVerifiedBot } = getBotCookies();
    params.exposureData.forEach(({ experimentKey, variationKey, unitType }) => {
      datadogRum.addFeatureFlagEvaluation(
        // The hyphen is not allowed according to DD documentation
        //  https://docs.datadoghq.com/real_user_monitoring/guide/setup-feature-flag-data-collection/?tab=browser#feature-flag-naming
        experimentKey?.replace('-', '_'),
        variationKey,
      );
      void analytics.track(
        ABSMARTLY_EXPERIMENT_BUCKETING_DECISION_EVENT,
        {
          ...(unitType === 'anonymous_id'
            ? {
                bucketing_id: params.anonymousId,
                bucketing_id_type: 'anonymous_id',
              }
            : {
                bucketing_id: params.deviceId,
                bucketing_id_type: 'device_id',
              }),
          additional_attributes: {
            decision_location: 'client',
          },
          deployable_name: 'cardfinder-v2',
          deployable_version: params.deployableVersion ?? '1.0.0',
          experiment_key: experimentKey,
          traditional_device_id: params.deviceId,
          user_agent: uuid(),
          user_attributes: {
            ...params.attributes,
          },
          variation_key: variationKey,
        },
        {
          context: {
            app: {
              name: 'cardfinder-v2',
              version: params.gitSha,
            },
          },
        },
      );
      void analytics.track(
        'Experiment Bucketing Decision',
        {
          ...(unitType === 'anonymous_id'
            ? {
                bucketing_id: params.anonymousId,
                bucketing_id_type: 'anonymous_id',
              }
            : {
                bucketing_id: params.deviceId,
                bucketing_id_type: 'device_id',
              }),
          additional_attributes: {
            ...params.attributes,
            decision_location: 'client',
            traditional_device_id: params.deviceId,
          },
          bot_management: {
            bot_score: botScore,
            is_bot: isBot,
            is_bot_user_agent: isBotUserAgent,
            is_verified_bot: isVerifiedBot,
          },
          deployable_name: 'cardfinder-v2',
          deployable_version: params.deployableVersion ?? '1.0.0',
          event_id: uuid(),
          experiment_key: experimentKey,
          user_agent: navigator.userAgent,
          variation_key: variationKey,
        },
        {
          context: {
            app: {
              name: 'cardfinder-v2',
              version: params.gitSha,
            },
          },
        },
      );
    });
  }
};
